import styled from "styled-components";
import { RowBody } from "./RowBody";
import { StyledCheckbox } from "../styledComponents/StyledCheckbox";

export const UnitSpan = styled.span`
  && {
    margin-left: 7px;
  }
`;

export function CheckableRowBody({
  isChecked,
  onChecked,
  titleValue,
  indicesValue,
  inputValue,
  unitValue,
  formulaValue,
}) {
  const hackedTitleValue = (
    <StyledCheckbox>
      <input type="checkbox" checked={isChecked} onChange={() => onChecked(!isChecked)} />
      <label style={{ fontWeight: "normal" }}>{titleValue}</label>
    </StyledCheckbox>
  );
  return (
    <RowBody
      titleValue={hackedTitleValue}
      indicesValue={indicesValue}
      inputValue={inputValue}
      unitValue={unitValue}
      formulaValue={formulaValue}
    />
  );
}
